import React, { useState } from "react";
//@ts-ignore
import { useParams } from 'react-router-dom'
import consts from "../../../shared/consts";
import store from "../store";
import Button from "./button";
import useFeature from "../utils/subscriptionWrapper";
import { delay } from "src/utils/react-utils";

function qs() {
  return require('qs').parse(location.search.slice(1))
}

export default function NewSimulationButton(props) {
  const { id } = useParams();
  var REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS);

  const onCreateNewSimulationBtnClick = async () => {
    store.creatingNewSimulation = true;
    store.updateStore()
    await delay(400)
    if (id) {
      await store.saveStory();
      await delay(100)
    }
    await store.createNewSimulation(props.isLoggedIn, REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS);
    store.creatingNewSimulation = false;
    store.updateStore();

    if(window["config"].SHOW_AI_FUNCTIONALITY == "YES" && qs().review_id) {
      store.openEnterSimulationNameModal();
    }
  }

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        loading={store.creatingNewSimulation}
        disabled={!props.isLoggedIn || store.creatingNewSimulation}
        onClick={() => { onCreateNewSimulationBtnClick() }}>
        <span css={'white-space:nowrap;'}>New simulation</span>
      </Button>
      {localStorage.showExport && <Imp />}
    </>
  )
}

function Imp() {
  var [dragOver, setDragOver] = useState(false)
  function onDragOver(e) {
    setDragOver(true)
    e.preventDefault()
  }
  function onDragLeave() {
    setDragOver(false)
  }
  async function fileChange(e) {
    for (let j = 0; j < e.target.files.length; j++) {
      var file = e.target.files[j]
      await new Promise(resolve => {
        let reader = new FileReader()
        reader.onload = async function () {
          var content = reader.result.toString()
          await store.newSimulation(JSON.parse(content))
          resolve()
        }
        reader.readAsText(file)
      })
    }
    alert('done. Refresh the page')
  }
  return <div css={`display:inline-block;position:relative;`}>
    <Button>
      {!dragOver && "Import"}
      {dragOver && "drop"}
    </Button>
    <input
      onChange={fileChange}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      // onDrop={onDrop}
      type="file" css={`
      position:absolute;
      cursor:pointer;
      width:100%;
      height:100%;
      opacity:0;
      left:0px;
      `} />
  </div>
}